/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { collectionWithCountsSchema } from '../collection-schema';

export const listCollectionsResponseDataSchema = z.array(collectionWithCountsSchema);

export type IListCollectionsResponseData = z.infer<typeof listCollectionsResponseDataSchema>;

export const listCollectionsResponseSchema = createApiResponseSchema(
  listCollectionsResponseDataSchema,
) as z.ZodSchema<IAPI<IListCollectionsResponseData>>;

export type IListCollectionsResponse = IAPI<IListCollectionsResponseData>;
